import { initDialogBehavior } from './dialog.js';

const initBioDialog = () => {
	const dialogs = document.querySelectorAll('.bio-dialog');
	if (!dialogs.length) return;
	dialogs.forEach((dialog) => initDialogBehavior(dialog));
};

export { initBioDialog };
